<template>
  <div id="ball" :style="{ 'background-image': backgroundImage, top, left, height, width}"></div>
</template>

<style scoped>
#ball
{ position:          absolute; 
  background-repeat: no-repeat;
  background-size:   cover;
}
</style>

<script>
import { mapState} from 'vuex'

const
  v_g = 981, // gravity
  
  // In order to avoid a scrollbar to appear if the ball
  // is placed too near the right or bottom border,
  // the stage is chosen to be one pixel smaller than the
  // window on each side.
  v_stage =
  { left:   1,
    right:  document.documentElement.clientWidth-1,
    top:    1,
    bottom: document.documentElement.clientHeight-1
  };

export default 
{ name: 'Ball',

  data()
  { return {
      d:        150, // diameter
      x:          1,
      y:          1,
      vx:       300,
      vy:         0,
      ax:         0,
      ay:         0,
      elasticity: 0.7, // super elastic ball (value 1.0)
                       // => no speed loss when it collides
                       //    with a wall
      stopped:    false,

      'backgroundImage': `url(${require('/img/owl-150.png')})`, 
      get left()   { return this.x + 'px' },
      get top()    { return this.y + 'px' },
      get width()  { return this.d + 'px' },
      get height() { return this.d + 'px' },
    }
  },

  computed:
  { ...mapState('gameloop', ['delta']) },

  watch:
  { delta(newDelta) { this.update(newDelta) } },

  methods:
  { update(p_delta_s = 1/60)
    { if (this.stopped)
      { return; }
      
      // stop a slow movement totally
      // (which is more realistic due to friction)
      if (this.y >= v_stage.bottom-this.d-2 && Math.abs(this.vy) < 80)
      { this.stopped = true;
        this.y = v_stage.bottom-this.d;
        return;
      }
      
      this. x += this.vx       * p_delta_s;
      this. y += this.vy       * p_delta_s;

      this.vx += this.ax       * p_delta_s;
      this.vy += (this.ay+v_g) * p_delta_s;
      
      if (this.x <= v_stage.left)
      { this. x = v_stage.left;
        this.vx = this.elasticity*Math.abs(this.vx);
        this.ax = Math.abs(this.ax);
      }
      else if (this.x >= v_stage.right-this.d)
      { this. x = v_stage.right-this.d;
        this.vx = -this.elasticity*Math.abs(this.vx);
        this.ax = -Math.abs(this.ax);
      }
      
      if (this.y <= v_stage.top)
      { this. y = v_stage.top;
        this.vy = this.elasticity*Math.abs(this.vy);
        this.ay = Math.abs(this.ay);
      }
      else if ( this.y >= v_stage.bottom-this.d)
      { this. y = v_stage.bottom-this.d;
        this.vy = -this.elasticity*Math.abs(this.vy);
        this.ay = -Math.abs(this.ay);
      }
    }  
  },
}
</script>

